import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ScrollDownButton } from '@radix-ui/react-select';
import { cn } from 'cn';
import { useTranslations } from 'use-intl';

interface Props extends React.ComponentPropsWithoutRef<
  typeof ScrollDownButton
> {
  ref?: React.Ref<React.ElementRef<typeof ScrollDownButton>>;
}

/**
 * @deprecated Use `SelectScrollDownButton` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function SelectScrollDownButton({ className, ref, ...props }: Props) {
  const t = useTranslations('Common');

  return (
    <ScrollDownButton
      data-test='select-scroll-down'
      aria-label={t('selectScrollDownAria')}
      ref={ref}
      className={cn(
        'flex cursor-default items-center justify-center py-1',
        className
      )}
      {...props}
    >
      <FontAwesomeIcon icon={faChevronDown} className='size-4' />
    </ScrollDownButton>
  );
}

export default SelectScrollDownButton;
